export enum TestStatus {
  Failed = "failed",
  Passed = "passed",
  All = "all",
}

export enum HistoryQueryParams {
  SelectedCommit = "selectedCommit",
  VisibleColumns = "visibleColumns",
  TaskID = "taskId",
}
